"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ttpHostnameConfig: ()=>ttpHostnameConfig,
    ttpJwtConfig: ()=>ttpJwtConfig,
    ttpOtherHostnameConfig: ()=>ttpOtherHostnameConfig,
    ttpProductBackupLinkV2Template: ()=>ttpProductBackupLinkV2Template
});
const ttpHostnameConfig = {
    'ttp-us': 'cloud.tiktok-usts.net',
    'tx-tt': 'cloud-tx.tiktokd.net',
    'ttp-row': 'cloud.tiktok-row.net',
    'ttp-row-sg': 'cloud-sg.tiktok-row.net',
    'ttp-eu': 'cloud-eu.tiktok-row.net',
    'ttp-eu-de': 'cloud-eu-de.tiktok-row.net'
};
const ttpOtherHostnameConfig = {
    backupTtpUs: 'cloud-backup.tiktok-usts.net'
};
const ttpJwtConfig = {
    ttpUsRow: 'https://cloud-ttp-us.tiktok-row.net/auth/api/v1',
    'i18n-eu-net': 'https://cloud-i18n.tiktok-eu.net/auth/api/v1',
    'i18n-eu-org': 'https://cloud-i18n.tiktok-eu.org/auth/api/v1',
    'ttp-us-org': 'https://cloud.tiktok-usts.org/auth/api/v1',
    'ttp-us-row-org': 'https://cloud-ttp-us.tiktok-row.org/auth/api/v1'
};
const ttpProductBackupLinkV2Template = 'https://cloud.tiktok-us.net/api/v1/cloud/get_cache/{file_key}.json';
exports.ttpHostnameConfig = __webpack_exports__.ttpHostnameConfig;
exports.ttpJwtConfig = __webpack_exports__.ttpJwtConfig;
exports.ttpOtherHostnameConfig = __webpack_exports__.ttpOtherHostnameConfig;
exports.ttpProductBackupLinkV2Template = __webpack_exports__.ttpProductBackupLinkV2Template;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ttpHostnameConfig",
    "ttpJwtConfig",
    "ttpOtherHostnameConfig",
    "ttpProductBackupLinkV2Template"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
